var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fixed z-99 right-0 top-1/2 transform -translate-y-1/2 rounded-l-lg shadow"},[_c('div',{staticClass:"overflow-hidden"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }